import React, { useContext } from "react";
import { Route as RouterRoute, Redirect, useLocation } from "react-router-dom";
import moment from "moment";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, alwaysRender = false, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);
	const location = useLocation();

	// Verificar se a empresa está vencida
	const isCompanyExpired = () => {
		if (!user || !user.company || user.company.id === 1) {
			return false; // Empresa ID 1 nunca expira
		}

		const dueDate = user.company.dueDate;
		if (!dueDate) return false;

		// Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
		const hojeInicio = moment().startOf('day');
		const vencimentoInicio = moment(dueDate).startOf('day');

		// Empresa está vencida apenas após o dia do vencimento
		return hojeInicio.isAfter(vencimentoInicio, 'day');
	};

	// Rotas marcadas com alwaysRender ignoram verificação de autenticação
	// (ex: /cadastro que gerencia auth internamente via PIN overlay)
	if (!alwaysRender) {
		// 24/09/2026, achado ao vivo (Patrick, tentando abrir /lara-voice direto por URL
		// numa aba nova): isAuth começa em "false" e loading em "true" (ver useAuth.js) -
		// numa navegação por CLIQUE dentro do app isso nunca dava problema (a sessão já
		// tinha carregado antes), mas ao digitar uma URL direto e apertar Enter (recarga
		// completa da página), essas duas checagens abaixo rodavam ENQUANTO ainda estava
		// carregando e mandavam pro /login por engano - que aí detectava a sessão válida e
		// devolvia pro painel normal, sem nunca chegar na página pedida. Agora espera a
		// checagem de sessão terminar (loading:false) antes de decidir redirecionar.
		if (loading) {
			return <BackdropLoading />;
		}

		if (!isAuth && isPrivate) {
			return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
		}

		if (isAuth && !isPrivate) {
			return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
		}
	}

	// Se está autenticado e a empresa está vencida
	if (isAuth && isPrivate && isCompanyExpired()) {
		// Permite acesso apenas ao /financeiro-aberto
		if (rest.path !== "/financeiro-aberto") {
			return (
				<>
					{loading && <BackdropLoading />}
					<Redirect to={{ pathname: "/financeiro-aberto", state: { from: rest.location } }} />
				</>
			);
		}
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
